import { QuestionEntity } from 'backend-entity';

export type CrmCreateQuestionRequestDto = Omit<QuestionEntity, 'id' | 'createdAt' | 'updatedAt'> &
  Partial<Pick<QuestionEntity, 'active'>>;
